import * as SkylineAPI from "./skylineApi"
import { byId, notyf } from "./utils"

export function prepareRoleSwitcher() {
  const root = document.querySelector(".userContainer")
  const elems = root.querySelectorAll(".userDropdown ul li")
  for (const elem of elems) {
    elem.addEventListener("click", async (ev) => {
      try {
        await SkylineAPI.getToken(elem.textContent)
      } catch (error) {
        notyf.error(error.message)
        return
      }
      root.querySelector(".userDropdown .selected")?.classList.remove("selected")
      elem.classList.add("selected")
      root.querySelector("span").textContent = elem.textContent

      applyRoles()
    })
  }
}

export function applyRoles() {
  const user = SkylineAPI.getUser()
  document.querySelectorAll("[data-role]").forEach( e => {
    e.style.display = "none"
    delete e.dataset.roleVisible
  })
  for(const role of user.scope?.split(";") || []) {
    if (role) {
      for( const node of document.querySelectorAll(`[data-role="${role}"]`) ) {
        node.style.display = "unset"
        node.dataset.roleVisible = "true"
      }
    }
  }
}
